<template>
    <div class="subnote-send">
        <p class="subnote">
            Um ein rechtsgültiges Vertragsverhältnis herstellen zu können, benötigen wir Ihre persönlichen Informationen. Diese Angaben werden natürlich vertraulich behandelt und sind ausschließlich für den internen Gebrauch bestimmt. Bei weiteren Fragen bitte unsere Datenschutzrichtlinie durchlesen.
        </p>
        <Button text="Weiter"></Button>
    </div>
</template>

<script>

import Button from '@/views/components/ui/Button'

export default {
    name: 'RegisterFormPartSubmitButton',
    components: {
        Button,
    },
}
</script>
